import { ErrorMessageConstants } from '../shared/error-message-constants';
var Error = /** @class */ (function () {
    function Error(code, message) {
        this.CAFE_PENDING_ORDER_ERROR = 'pending order';
        this.CAFE_REACH_CHECKED_ORDER_ERROR = 'OCAPI-ERR-4123';
        this.code = code;
        this.message = message;
        return this;
    }
    Error.prototype.isWaitingActivation = function () {
        return this.code === ErrorMessageConstants.OCAPI_ERR_ODSO123;
    };
    Error.prototype.isOrderPending = function () {
        return this.message.toLowerCase().indexOf(this.CAFE_PENDING_ORDER_ERROR) !== -1;
    };
    Error.prototype.isReachCheckFailed = function () {
        return this.code.indexOf(this.CAFE_REACH_CHECKED_ORDER_ERROR) !== -1;
    };
    return Error;
}());
export { Error };
